import React from 'react'
import { IconProps } from '@/checkout-instore-legacy/components/Commons/Icons/IconProps'

export function PickupPackage({
  style,
  color = 'currentColor',
  height = 20,
  width = 22,
}: IconProps) {
  const styleIcon = {
    fill: color,
    verticalAlign: 'middle',
    ...style,
  }
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 20"
      fill="none"
      style={styleIcon}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.22266 8.14057C3.63687 8.14057 3.97266 8.47636 3.97266 8.89057V18.8906C3.97266 19.3048 3.63687 19.6406 3.22266 19.6406C2.80844 19.6406 2.47266 19.3048 2.47266 18.8906V8.89057C2.47266 8.47636 2.80844 8.14057 3.22266 8.14057Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7812 8.14057C19.1955 8.14057 19.5312 8.47636 19.5312 8.89057V18.8906C19.5312 19.3048 19.1955 19.6406 18.7812 19.6406C18.367 19.6406 18.0312 19.3048 18.0312 18.8906V8.89057C18.0312 8.47636 18.367 8.14057 18.7812 8.14057Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.0293 14.4456C8.0293 12.8044 9.36008 11.4736 11.0013 11.4736C12.6425 11.4736 13.9733 12.8044 13.9733 14.4456V18.8896C13.9733 19.3038 13.6375 19.6396 13.2233 19.6396C12.8091 19.6396 12.4733 19.3038 12.4733 18.8896V14.4456C12.4733 13.6328 11.8141 12.9736 11.0013 12.9736C10.1885 12.9736 9.5293 13.6328 9.5293 14.4456V18.8896C9.5293 19.3038 9.19351 19.6396 8.7793 19.6396C8.36508 19.6396 8.0293 19.3038 8.0293 18.8896V14.4456Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.251953 18.8906C0.251953 18.4764 0.58774 18.1406 1.00195 18.1406H21.002C21.4162 18.1406 21.752 18.4764 21.752 18.8906C21.752 19.3048 21.4162 19.6406 21.002 19.6406H1.00195C0.58774 19.6406 0.251953 19.3048 0.251953 18.8906Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.06311 1.86157C4.42737 1.86157 3.87283 2.20602 3.61684 2.71014L1.90182 6.08717C1.44871 6.97924 2.09764 8.12941 3.30483 8.13957C4.43015 8.13837 5.11888 7.39246 5.12111 6.7255V6.67857C5.12111 6.26436 5.4569 5.92857 5.87111 5.92857C6.28533 5.92857 6.62111 6.26436 6.62111 6.67857C6.62111 7.38443 7.32562 8.13957 8.43711 8.13957C9.5486 8.13957 10.2531 7.38443 10.2531 6.67857C10.2531 6.26436 10.5889 5.92857 11.0031 5.92857C11.4173 5.92857 11.7531 6.26436 11.7531 6.67857C11.7531 7.38443 12.4576 8.13957 13.5691 8.13957C14.6806 8.13957 15.3851 7.38443 15.3851 6.67857C15.3851 6.26436 15.7209 5.92857 16.1351 5.92857C16.5493 5.92857 16.8851 6.26436 16.8851 6.67857V6.72657C16.8851 7.39174 17.5719 8.13837 18.6984 8.13957C19.9055 8.12941 20.5545 6.97938 20.1015 6.08733L18.3855 2.71033C18.1295 2.20621 17.5749 1.86157 16.9391 1.86157H5.06311ZM16.1262 8.5687C15.4995 9.23796 14.5554 9.63957 13.5691 9.63957C12.5781 9.63957 11.6298 9.23415 11.0031 8.55919C10.3764 9.23415 9.42811 9.63957 8.43711 9.63957C7.45014 9.63957 6.50552 9.23743 5.87876 8.56739C5.24891 9.23954 4.29209 9.63957 3.30211 9.63957H3.29681C1.10968 9.62412 -0.454111 7.41326 0.564405 5.40797M0.564405 5.40797L2.27939 2.031C2.80541 0.99514 3.89487 0.361572 5.06311 0.361572H16.9391C18.1073 0.361572 19.1967 0.995046 19.7227 2.03081L21.4387 5.40781C22.4573 7.41311 20.8936 9.6241 18.7064 9.63955L18.7011 9.63957C17.7124 9.63957 16.7558 9.24022 16.1262 8.5687"
        fill={color}
      />
    </svg>
  )
}
